import { h } from 'preact';
import { deviceVariance } from '@cube/blocks';
import Mobile from './mobile';
import Desktop from './desktop';

const Footer = deviceVariance({
	phone: Mobile,
	tablet: Mobile
})(Desktop);

// Fully responsive header
export default Footer;

// Mobile only header
export const MobileFooter = Mobile;

// Desktop only header
export const DesktopFooter = Desktop;